import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { isLoggedInUser } from '../../../utils/isLoggedInUser';
import { MP_CLICKED_CONTACT_ME } from '../../../utils/mixPanelEvents';
import { BQ_CLICKED_CONTACT_SELLER } from '../../../utils/bigQueryEvents';
import { JS_JOIN_HOOK } from '../../../utils/constants';

import './style.scss';

const ContactSellerBtn = (props, { pathfinderWrapper, requestContext, biEvents, general }) => {

    const onClick = () => {
        biEvents.sendMixPanelEvent({
            eventName: MP_CLICKED_CONTACT_ME,
            params: { 'Source component': 'Gig page sticky' }
        });

        biEvents.sendBigQueryEvent({
            eventName: BQ_CLICKED_CONTACT_SELLER,
            params: { name: 'contact_seller' }
        });
    };

    const { username } = requestContext.params;
    const url = pathfinderWrapper.pathfinder('conversation', { id: username });
    const btnClassName = classNames(
        'btn-contact-seller',
        'js-contact-me',
        { [JS_JOIN_HOOK]: !isLoggedInUser(requestContext.current_user) }
    );

    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY;

    return (
        <div className="contact-seller-wrapper">
            <Button href={url} className={btnClassName} onClick={onClick} color={btnColor} fill={Button.FILLS.GHOST}>
                <I18n k={'gig_page_perseus.contact_seller.title'}/>
            </Button>
        </div>
    );
};

ContactSellerBtn.contextTypes = {
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object,
    biEvents: PropTypes.object,
    general: PropTypes.object
};

export default ContactSellerBtn;
